import { ParalelArivals } from './ParalelArivals';

export default ParalelArivals;
